import React, { useState } from 'react';
import { useStore } from "../../app/stores/store";
import { Button, Grid, Header, Tab } from "semantic-ui-react";
import { observer } from 'mobx-react-lite';
import ProfileUpdatePassword from './ProfileUpdatePassword';
export default observer(function ProfilePassword() {
    const { profileStore } = useStore();
    const { isCurrentUser, profile } = profileStore;
    const [editMode, setEditMode] = useState(false);
    return (
        <Tab.Pane>
            <Grid>
                <Grid.Column width='16'>
                    <Header floated='left' icon='user' content={`Update Password ${profile ? profile.fullName : ''}`} />
                    {isCurrentUser && (
                        <Button
                            floated='right'
                            basic
                            content={editMode ? 'Cancel' : 'Update Password'}
                            onClick={() => setEditMode(!editMode)}
                        />
                    )}
                </Grid.Column>
                <Grid.Column width='16'>
                    {editMode ? <ProfileUpdatePassword setEditMode={setEditMode} /> :
                        <span style={{ whiteSpace: 'pre-wrap' }}>{profile ? profile!.email : ''}</span>}
                </Grid.Column>
            </Grid>
        </Tab.Pane>
    )
})